import moment from "moment-timezone";
import { useTranslation } from "react-i18next";
import { useDateFormatPreference } from "@/hooks/use-date-format-preference";
import { parseDateTimeInput } from "@/utils/date-format-config";

const useDateFormat = () => {
  const { t } = useTranslation();
  const dir: "rtl" | "ltr" = t("direction");
  const { config } = useDateFormatPreference();

  // keep it to format dates for the API request body and url filters
  const GetDateFormat = (date: Date) => {
    const utcDate = moment.utc(date);
    let format = "YYYY-MM-DD HH:mm";
    if (dir == "rtl") {
      format = "HH:mm YYYY-MM-DD";
    }
    return utcDate.local().format(format);
  };

  // ISO (2024-11-04T15:22:48) or API legacy (25-05-2026 16:39) → display per preference
  const formatISODateTime = (date: Date | string) => {
    const parsed = parseDateTimeInput(date);
    if (!parsed.isValid()) {
      return "";
    }
    return parsed.local().format(config.dateTimeMoment);
  };

  // API legacy strings (DD-MM-YYYY) → display per preference (e.g. MM/DD/YYYY when US)
  const formatCustomDateTime = (date: Date | string) => {
    const parsed = parseDateTimeInput(date);
    if (!parsed.isValid()) {
      return "";
    }
    return parsed.local().format(config.customDateTimeMoment);
  };

  const formatISODate = (date: Date | string) => {
    const parsed = parseDateTimeInput(date);
    if (!parsed.isValid()) {
      return "";
    }
    return parsed.local().format(config.dateMoment);
  };

  return {
    GetDateFormat,
    formatISODateTime,
    formatCustomDateTime,
    formatISODate,
    dateFormatConfig: config,
  };
};

export { useDateFormat };
